import getHereTileBoxes from './get-here-tile-boxes';

export async function getHereAttributionMessage(bounds, level) {
  const tileBoxes = await getHereTileBoxes();
  const copyrights = [];
  tileBoxes.forEach(attribution => {
    const overlaps = attribution.boxes.some(b => bounds.intersects(b));

    if (
      overlaps > 0 &&
      level > attribution.minLevel &&
      level < attribution.maxLevel
    ) {
      copyrights.push(attribution.label);
    }
  });

  const copyrightString = copyrights.join(', ');
  return ` &copy; 1987-2019 HERE${
    copyrightString.length > 0 ? `, ${copyrightString}` : ''
  } | <a href="https://legal.here.com/en/terms/serviceterms/us">Terms of Use</a>`;
}

export default getHereAttributionMessage;
